import "./Header.scss";

import { Dropdown } from "bootstrap";

export { Dropdown };

class Header {
  constructor(node) {
    this.node = node;
  }

  init() {

    /**
     * Height navbar
     */
    const navbarHeight = document.getElementById("navbar").offsetHeight;
    document.body.style.setProperty('--height-navbar', `${navbarHeight}px`);

    /**
     * Menu shrink
     */
    window.onscroll = function () {
      if (
        document.body.scrollTop > 80 ||
        document.documentElement.scrollTop > 80
      ) {
        document.getElementById("navbar").classList.add("shrink");
      } else {
        document.getElementById("navbar").classList.remove("shrink");
      }
    };

    window.onload = function () {
      const yOffset = window.pageYOffset;
      if (yOffset > 80) {
        document.getElementById("navbar").classList.add("shrink");
      }
    };

    /**
     * Disable Bg scrolling
     * let disableBgScrolling = function() {
     * const html = document.querySelector('html');
     * if (html.classList.contains('blocked')) {
     *   html.classList.remove('blocked');
     * } else {
     *   html.classList.add('blocked');
     * }
     *
     *
     * document.getElementById("navbar-toggler").addEventListener("click", function () {
     *   disableBgScrolling();
     * });
     *
     */

    /**
     * Megamenu action
     * const megamenuGroup = document.getElementsByClassName('navbar')[0];
     * megamenuGroup.addEventListener('show.bs.dropdown', function () {
     *   disableBgScrolling();
     * });
     * megamenuGroup.addEventListener('hide.bs.dropdown', function () {
     *   disableBgScrolling();
     * });
     */
  }
}

JSModules["Header"] = Header;
export default Header;
